import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

export const Confidentialite = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-sand-50">
      <div className="bg-white border-b border-sand-200 px-6 py-4 sticky top-0 z-10">
        <div className="flex items-center gap-3">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)}>
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <h1 className="text-xl font-serif text-sage-700">Politique de confidentialité</h1>
        </div>
      </div>

      <div className="px-6 py-8 max-w-2xl mx-auto prose prose-sage">
        <p className="text-sm text-sage-500">Dernière mise à jour : Avril 2026</p>

        <h2>Responsable du traitement</h2>
        <p>
          Lynda Bry-Bonnard<br />
          Email : brylynda@gmail.com
        </p>

        <h2>Données collectées</h2>
        <p>Nous collectons les données suivantes :</p>
        <ul>
          <li><strong>Données de compte :</strong> adresse email, mot de passe (crypté)</li>
          <li><strong>Données d'utilisation :</strong> progression dans le programme, audios écoutés, chapitres lus</li>
          <li><strong>Données de paiement :</strong> traitées de manière sécurisée par Stripe (nous ne stockons pas vos coordonnées bancaires)</li>
          <li><strong>Journal de bord :</strong> notes personnelles que vous choisissez d'enregistrer (facultatif)</li>
        </ul>

        <h2>Finalités du traitement</h2>
        <p>Vos données sont utilisées pour :</p>
        <ul>
          <li>Vous permettre d'accéder à votre compte et au programme</li>
          <li>Sauvegarder votre progression</li>
          <li>Personnaliser votre expérience</li>
          <li>Vous contacter en cas de besoin (support, mises à jour importantes)</li>
        </ul>

        <h2>Base légale</h2>
        <p>
          Le traitement de vos données repose sur l'exécution du contrat (accès au programme acheté) 
          et votre consentement pour les fonctionnalités optionnelles (journal de bord).
        </p>

        <h2>Durée de conservation</h2>
        <p>
          Vos données sont conservées pendant toute la durée de votre accès au programme. 
          En cas de suppression de votre compte, vos données seront effacées sous 30 jours.
        </p>

        <h2>Partage des données</h2>
        <p>
          Vos données ne sont jamais vendues à des tiers. Elles peuvent être partagées avec :
        </p>
        <ul>
          <li><strong>Stripe :</strong> pour le traitement des paiements</li>
          <li><strong>Notre hébergeur :</strong> pour le stockage sécurisé</li>
        </ul>

        <h2>Vos droits</h2>
        <p>Conformément au RGPD, vous disposez des droits suivants :</p>
        <ul>
          <li><strong>Droit d'accès :</strong> obtenir une copie de vos données</li>
          <li><strong>Droit de rectification :</strong> corriger vos données</li>
          <li><strong>Droit à l'effacement :</strong> supprimer vos données</li>
          <li><strong>Droit à la portabilité :</strong> récupérer vos données dans un format lisible</li>
          <li><strong>Droit d'opposition :</strong> vous opposer à certains traitements</li>
        </ul>
        <p>
          Pour exercer ces droits, contactez-nous à : brylynda@gmail.com
        </p>

        <h2>Cookies</h2>
        <p>
          L'application utilise des cookies techniques essentiels au fonctionnement (session de connexion). 
          Aucun cookie publicitaire ou de tracking n'est utilisé.
        </p>

        <h2>Sécurité</h2>
        <p>
          Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos données : 
          chiffrement des mots de passe, connexion sécurisée (HTTPS), accès restreint aux données.
        </p>

        <h2>Contact</h2>
        <p>
          Pour toute question relative à vos données personnelles : brylynda@gmail.com
        </p>
      </div>
    </div>
  );
};

export default Confidentialite;
